export const enum AccessStatus {
  Initial = 'initial',
  Authenticated = 'authenticated',
  Invalid = 'invalid',
}
